<template>
  <div
    style="width: 100%; height: 100%"
    ref="chartsDom"
    class="chartsDom"
  ></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chartsDom",
  props: {
    list: Object,
  },
  data() {
    return {
      goToSchoolTwo: {},
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.goToSchoolTwo = newVal;
        if (true) {
          this.$nextTick(() => {
            this.initNYNM();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.goToSchoolTwo = this.list;
    this.$nextTick(() => {
      this.initNYNM();
    });
    window.addEventListener("resize", () => {
      this.$echarts.init(this.$refs.chartsDom).resize();
    });
  },
  methods: {
    initNYNM() {
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表

      let myChart = this.$echarts.init(this.$refs.chartsDom);
      // 2. 指定配置和数据

      let goToSchoolTwo = this.goToSchoolTwo;
      let pieSource = {
        养老护理员: 335,
        保健按摩师: 335,
        老年能力评估师: 335,
        护师资格证: 335,
        其他: 335,
      };
      var uploadedDataURL2 =
        "data:image/png;base64,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";

      let legendColor = [
        "#24EACD",
        "#FFFA92",
        "#13E7FF",
        "#FF0009",
        "#00B5FF",
        "#FAEAA1",
        "#3AA2E8",
        "#5fc6fc",
      ];
      let richStyle = {
        title: {
          fontSize: 12,
          color: "rgb(0, 178, 246)",
          padding: [5, 0, 0, 8],
        },
        value: {
          fontSize: 12,
          // lineHeight: 20,
          color: "#fff",
          padding: [5, 0, 0, 8],
        },
      };

      function initData(source) {
        // legendColor.map((item, index) => {
        //     richStyle["style" + index] = {};
        //     richStyle["style" + index]["color"] = item;
        //     richStyle["style" + index]["align"] = "right";
        // });
        if (Object.prototype.toString.call(source) === "[object Object]") {
          const arr = [];
          const legendData = [];
          Object.entries(source).forEach((value) => {
            legendData.push(value[0]);
            let obj = {};
            obj.name = value[0];
            obj.value = value[1];
            arr.push(obj);
          });
          source = arr;
          return {
            source,
            legendData,
          };
        } else if (
          source &&
          Object.prototype.toString.call(source) === "[object Array]"
        ) {
          let legendData = [];
          source.forEach((item, index) => {
            legendData.push(item.name);
          });
          return {
            source,
            legendData,
          };
        }
      }

      let source = initData(pieSource);
      // console.log('source:', source);
      let option = {
        title: {
          text: "100%",
          subtext: "  执证率",
          textStyle: {
            color: "#FFE76D",
            fontSize: 24,
            // align: 'center'
          },
          subtextStyle: {
            fontSize: 14,
            color: "#fff",
          },
          x: "20.1%",
          y: "38%",
        },
        tooltip: {
          trigger: "item",
          textStyle: {
            color: "#000",
          },
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        color: legendColor,
        legend: {
          type: "scroll",
          orient: "vertical",
          right: "10%",
          top: "center",
          itemGap: 30,
          selectedMode: false,
          icon: "pin",
          data: source.legendData.slice(0, 3),
          textStyle: {
            color: "#77899c",
            rich: {
              uname: {
                width: 100,
              },
              unum: {
                color: "#4ed139",
                width: 40,
                align: "right",
              },
            },
          },
          formatter(name) {
            return `{uname|${name}}{unum|1132}`;
          },
        },
        legend: [
          {
            left: 250,
            y: "center",
            icon: "rect",
            // icon: "circle",
            textStyle: {
              color: "#fff",
              fontSize: 12,
              rich: richStyle,
              width: 153,
              height: 24,
              backgroundColor: {
                image: uploadedDataURL2,
              },
            },
            padding: [30, 0, 30, 0],
            itemWidth: 12,
            itemHeight: 12,
            // itemGap: 35,
            icon: "circle",
            top: "center",
            left: "60%",
            // data: source.legendData.slice(0, 3),
            data: source.legendData,
            formatter: function (name) {
              let oa = option.series[0].data;
              let total = 0;
              oa.forEach((item, index) => {
                total += item.value;
              });
              for (let i = 0; i < oa.length; i++) {
                if (name == oa[i].name) {
                  // return name + '  ' + '{style'+i+'|' + (oa[i].value / total * 100).toFixed(2) + '%}';
                  // return (name + "{style" + i + "|" + ((oa[i].value / total) * 100).toFixed(2) + "%}");
                  // return (name + "{style" + i + "|" + ((oa[i].value / total) * 100).toFixed(2) + "%}");
                  // return "{title|" + ((oa[i].value / total) * 100).toFixed(2) + "%" + "}\n{value|" + name + "}"
                  return (
                    "{value|" +
                    name +
                    "}：{title|" +
                    ((oa[i].value / total) * 100).toFixed(1) +
                    "%" +
                    "}"
                  );
                }
              }
            },
          },
          // {
          //     orient: "vertical",
          //     left: 370,
          //     y: "center",
          //     icon: "rect",
          //     icon: "circle",
          //     textStyle: {
          //         color: "#cddafd",
          //         fontSize: 12,
          //         rich: richStyle,
          //         width: 80,
          //         height: 40,
          //         backgroundColor: {
          //             // image: "/asset/get/s/data-1545016257824-mxLqGjr4z.png",
          //             image: uploadedDataURL2,
          //         },
          //     },
          //     // padding: [30, 0, 30, 0],
          //     itemWidth: 10,
          //     itemHeight: 7,
          //     itemGap: 35,
          //     data: source.legendData.slice(3),
          //     formatter: function (name) {
          //         let oa = option.series[0].data;
          //         let total = 0;
          //         oa.forEach((item, index) => {
          //             total += item.value;
          //         });
          //         for (let i = 0; i < oa.length; i++) {
          //             if (name == oa[i].name) {
          //                 return "{title|" + ((oa[i].value / total) * 100).toFixed(2) + "%" + "}\n{value|" + name + "}"
          //             }
          //         }
          //     },
          // },
        ],
        series: [
          {
            name: "持证率",
            type: "pie",
            radius: ["64%", "85%"],
            center: ["27.5%", "50%"],
            data: source.source,
            label: {
              show: false,
            },
            itemStyle: {
              // shadowColor: "#438bff",
              // shadowBlur: 20,
              // 设置边框宽度来创建空隙
              borderWidth: 8,
              // 设置边框颜色，通常与背景色相同
              borderColor: "RGBA(1, 30, 66, 1)",
            },
          },
        ],
      };
      // 其他各种图表一个原理
      // let index = 0;
      // setInterval(function () {
      //     // 这里的7 为x轴的长度
      //     if (index >= 7) {
      //         index = 0;
      //     }
      //     myChart.dispatchAction({
      //         type: "showTip", // 提示框
      //         seriesIndex: 0,
      //         dataIndex: index // 第 lightIndex 柱子高亮
      //     });
      //     index += 1;
      // }, 2000);
      // 3. 把配置给实例对象
      myChart.setOption(option);
      // 4. 让图表跟随屏幕自动的去适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>
